import React, { useEffect, useRef, useState } from "react";
import RoadmapCss from "./style";
import { makeStyles } from "@material-ui/core/styles";
import Timeline from "@material-ui/lab/Timeline";
import TimelineItem from "@material-ui/lab/TimelineItem";
import TimelineSeparator from "@material-ui/lab/TimelineSeparator";
import TimelineConnector from "@material-ui/lab/TimelineConnector";
import TimelineContent from "@material-ui/lab/TimelineContent";
import TimelineOppositeContent from "@material-ui/lab/TimelineOppositeContent";
import TimelineDot from "@material-ui/lab/TimelineDot";
import FastfoodIcon from "@material-ui/icons/Fastfood";
import LaptopMacIcon from "@material-ui/icons/LaptopMac";
import HotelIcon from "@material-ui/icons/Hotel";
import RepeatIcon from "@material-ui/icons/Repeat";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

const Roadmap = () => {
  const paraRef = useRef();
  const [visible, setVisible] = useState(false);
  const observer = React.useRef(
    new IntersectionObserver(
      (enteries, ob) => {
        enteries.forEach(entry => {
          if (entry.isIntersecting) setVisible(true);
        });
      },
      { root: null, rootMargin: "-200px 0px", threshold: 0 }
    )
  );
  useEffect(() => {
    observer.current.observe(paraRef.current);
  }, []);

  let classes = "title";
  if (visible) {
    classes += " fadeIn";
  }
  return (
    <RoadmapCss>
      <div className="wrapper">
        <div className={classes} ref={paraRef}>
          Roadmap
        </div>
        <div className="top">
          <div className="q2">
            <div className="q_title">Q2-2021</div>
            <div className="q_text">
              <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                <li>IFO</li>
                <li>Burn IFO LPs</li>
              </ul>
            </div>
          </div>
          <div className="q4">
            <div className="q_title">Q4-2021</div>
            <div className="q_text">
              <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                <li>Execute first payouts for CETO Bonds</li>
                <li>Merch</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="middle">
          <img src="r_circle.png" alt="x" className="c1" />
          <img src="r_circle.png" alt="x" className="c2" />
          <img src="r_circle.png" alt="x" className="c3" />
          <img src="r_circle.png" alt="x" className="c4" />
        </div>
        <div className="bottom">
          <div className="q3">
            <div className="q_title">Q3-2021</div>
            <div className="q_text">
              <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                <li> IFO</li>
                <li> Start monthly airdrops</li>
                <li> Fund development for CETO Blockchain Family products</li>
                <li> Launch Big Tent for BCETO/CEFA</li>
                <li> Get listed on major exchanges</li>
                <li> Launch CETO Bonds</li>
                <li> Lock CEFA-BNB liquidity</li>
                <li> Start farming on PancakeSwap</li>
              </ul>
            </div>
          </div>
          <div className="q1">
            <div className="q_title">Q1-2022</div>
            <div className="q_text">
              <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                <li> More of the same</li>
                <li>Decentralized exchange</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="tab_view">
          <div className="left">
            <div className="q3">
              <div className="q_title">Q3-2021</div>
              <div className="q_text">
                <ul>
                  <li>Start monthly airdrops</li>
                  <li> Fund development for CETO Blockchain Family products</li>
                  <li> Launch Big Tent for BCETO/CEFA</li>
                  <li> Get listed on major exchanges</li>
                  <li> Launch CETO Bonds</li>
                  <li> IFO</li>
                  <li> Lock CEFA-BNB liquidity</li>
                  <li> Start farming on PancakeSwap</li>
                </ul>
              </div>
            </div>
            <div className="q1">
              <div className="q_title">Q1-2022</div>
              <div className="q_text">
                <ul>
                  <li> More of the same</li>
                  <li>Decentralized exchange</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="middle_section">
            <img src="r_circle.png" alt="x" className="c11" />
            <img src="r_circle.png" alt="x" className="c22" />
            <img src="r_circle.png" alt="x" className="c33" />
            <img src="r_circle.png" alt="x" className="c44" />
          </div>
          <div className="right">
            <div className="q2">
              <div className="q_title">Q2-2021</div>
              <div className="q_text">
                <ul>
                  <li>IFO</li>
                  <li>Burn IFO LPs</li>
                </ul>
              </div>
            </div>
            <div className="q4">
              <div className="q_title">Q4-2021</div>
              <div className="q_text">
                <ul>
                  <li>Execute first payouts for CETO Bonds</li>
                  <li>Merch</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mobile_view">
          <div className="timeline">
            <img src="r_circle.png" alt="x" className="c111" />
            <img src="r_circle.png" alt="x" className="c222" />
            <img src="r_circle.png" alt="x" className="c333" />
            <img src="r_circle.png" alt="x" className="c444" />
          </div>
          <div className="right">
            <div className="q2">
              <div className="q_title">Q2-2021</div>
              <div className="q_text">
                <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                  <li>IFO</li>
                  <li>Burn IFO LPs</li>
                </ul>
              </div>
            </div>
            <div className="q3">
              <div className="q_title">Q3-2021</div>
              <div className="q_text">
                <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                  <li> IFO</li>
                  <li>Start monthly airdrops</li>
                  <li> Fund development for CETO Blockchain Family products</li>
                  <li> Launch Big Tent for BCETO/CEFA</li>
                  <li> Get listed on major exchanges</li>
                  <li> Launch CETO Bonds</li>
                  <li> Lock CEFA-BNB liquidity</li>
                  <li> Start farming on PancakeSwap</li>
                </ul>
              </div>
            </div>
            <div className="q4">
              <div className="q_title">Q4-2021</div>
              <div className="q_text">
                <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                  <li>Execute first payouts for CETO Bonds</li>
                  <li>Merch</li>
                </ul>
              </div>
            </div>
            <div className="q1">
              <div className="q_title">Q1-2022</div>
              <div className="q_text">
                <ul style={{ listStyle: "disc", paddingLeft: "1rem" }}>
                  <li> More of the same</li>
                  <li>Decentralized exchange</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </RoadmapCss>
  );
};
const useStyles = makeStyles(theme => ({
  paper: {
    padding: "6px 16px"
  },
  secondaryTail: {
    backgroundColor: theme.palette.secondary.main
  }
}));

function CustomizedTimeline() {
  const classes = useStyles();

  return (
    <Timeline align="alternate">
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot></TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Eat
            </Typography>
            <Typography>Because you need strength</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent>
          <Typography variant="body2" color="textSecondary">
            10:00 am
          </Typography>
        </TimelineOppositeContent>
        <TimelineSeparator>
          <TimelineDot color="primary">
            <LaptopMacIcon />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Code
            </Typography>
            <Typography>Because it&apos;s awesome!</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="primary" variant="outlined">
            <HotelIcon />
          </TimelineDot>
          <TimelineConnector className={classes.secondaryTail} />
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Sleep
            </Typography>
            <Typography>Because you need rest</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineSeparator>
          <TimelineDot color="secondary">
            <RepeatIcon />
          </TimelineDot>
        </TimelineSeparator>
        <TimelineContent>
          <Paper elevation={3} className={classes.paper}>
            <Typography variant="h6" component="h1">
              Repeat
            </Typography>
            <Typography>Because this is the life you love!</Typography>
          </Paper>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}

export default Roadmap;
